import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { db ,auth} from "../../Lib/Firebase/Firebase";
import FireLoginStatus from "../../Lib/Firebase/FireLoginStatus";
import { pageWrapper } from "../App/App";
import { FaRegPlusSquare } from 'react-icons/fa';
import "./PlaceBooking.css"

const PlaceBooking = ({chosenDate}) => {
  
  let stateObj=useContext(pageWrapper)
  let [user]=FireLoginStatus()

  let history = useHistory();
  function checkLoginAndServiceChosen(){
    

    if(stateObj.state.ServiceRequired ==="SERVICE_REQUIRED" || !user ){
      
    }else{
      


          sendToFireBase()

          // HERE IS WHERE YOU CHANGE THE PAGE!!
          
      // HERE IS WHERE YOU CHANGE THE PAGE!!
      history.push("/ConfirmPage");
    }
  }

  function sendToFireBase(){
    
    db.child(auth.currentUser.uid).update({
      date:`${chosenDate.toString().split(" ").slice(0,4)}`,
      service:stateObj.state.ServiceRequired,
      bookingStatus:"pending"
    })
  }

  return ( 
    <button onClick={checkLoginAndServiceChosen}
     className="place-booking">Place booking<FaRegPlusSquare/></button>
   );
}
 
export default PlaceBooking;